import {connect} from '@modifi/redux'

import SubmitShipment, {SubmitShipmentProps} from './SubmitShipment'
import {
  selectSubmitHasError,
  selectSubmitPending,
  aReset,
  aShowSubmitProgressDialog,
  aTriggerEvent,
} from '../../store'

const mapStateToProps = (
  state: Record<string, any>
): Pick<SubmitShipmentProps, 'submitPending' | 'submitHasError'> => ({
  submitPending: selectSubmitPending(state),
  submitHasError: selectSubmitHasError(state),
})

const mapDispatchToProps = {
  submit: aShowSubmitProgressDialog,
  reset: aReset,
  triggerEvent: aTriggerEvent,
}

export default connect(mapStateToProps, mapDispatchToProps)(SubmitShipment)
